import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Termini e Condizioni</h1>
      <p>
        Benvenuti su Escavatori Rent. Utilizzando il nostro sito, accetti i
        seguenti termini e condizioni.
      </p>
      <h2 className="text-xl font-bold mt-4">Uso del sito</h2>
      <p>
        Il contenuto del sito è fornito solo a scopo informativo. Non garantiamo
        l'accuratezza, la completezza o la tempestività delle informazioni
        fornite.
      </p>
      <h2 className="text-xl font-bold mt-4">Limitazioni di responsabilità</h2>
      <p>
        Non saremo responsabili per eventuali danni derivanti dall'uso del sito
        o delle informazioni in esso contenute.
      </p>
      <h2 className="text-xl font-bold mt-4">Modifiche ai termini</h2>
      <p>
        Ci riserviamo il diritto di modificare questi termini in qualsiasi
        momento. Le modifiche saranno pubblicate su questa pagina e l'uso
        continuato del sito implica l'accettazione dei nuovi termini.
      </p>

      {/* <h2 className="text-xl font-bold mt-4">
        Disclaimer sulle Immagini Utilizzate
      </h2>
      <p>
        Le immagini presenti su questo sito, relative ai nostri escavatori e
        servizi di noleggio, sono a scopo dimostrativo. Alcune delle foto
        attualmente utilizzate sono temporanee e saranno sostituite con immagini
        originali e aggiornate nel più breve tempo possibile. Ci impegniamo a
        fornire una rappresentazione accurata dei nostri prodotti e servizi, e
        stiamo lavorando per garantire che tutte le immagini sul nostro sito
        riflettano fedelmente ciò che offriamo. Vi ringraziamo per la vostra
        comprensione e pazienza durante questo periodo di aggiornamento.
      </p> */}

      <h2 className="text-xl font-bold mt-4">Contatti</h2>
      <p>
        Per domande sui nostri termini e condizioni, contattaci contattaci su
        WhatsApp.
      </p>
    </div>
  );
};

export default TermsAndConditions;
